export enum KategoriSvarId {
    SkadeBygningEiendom = 'Hjem_SkadeBygningEiendom',
    BygningLekkasjeOgVannskader = 'HusOgHytte_BygningLekkasjeOgVannskader',
    BygningBrannOgElektriskeSkader = 'HusOgHytte_BygningBrannOgElektriskeSkader',
    BygningGlasskade = 'HusOgHytte_Glasskade',
    BygningInnbruddOgHarverk = 'HusOgHytte_InnbruddOgHarverk',
    BygningSoppRateOgSkadedyr = 'HusOgHytte_SoppRateOgSkadedyr',
    BygningNaturskade = 'HusOgHytte_Naturskade',
    BygningAnnet = 'HusOgHytte_Annet',
    BygningNaturskadeStorm = 'Bygning_Naturskade_Storm',
    BygningNaturskadeFlom = 'Bygning_Naturskade_Flom',
    BygningNaturskadeSkred = 'Bygning_Naturskade_Skred',
    BygningNaturskadeAnnen = 'Bygning_Naturskade_Annen',
    BygningElektriskeSkader = 'Bygning_ElektriskeSkader',
    BygningBrannskaderOgSot = 'Bygning_BrannskaderOgSot',
    BygningBrannskadeAnnen = 'Bygning_BrannskadeAnnen',
    BygningInnbrudd = 'Bygning_Innbrudd',
    BygningHarverk = 'Bygning_Harverk',

    InnboMobilNettbrettEllerPc = 'Innbo_MobilNettbrettEllerPc',
    InnboTvOgAndreElektriskeArtikler = 'Innbo_TvOgAndreElektriskeArtikler',
    InnboEiendelerSykkeltyveri = 'Innbo_Sykkeltyveri',
    InnboTyveri = 'Innbo_Tyveri',
    InnboOdelagteMatvarerIFryserEllerKjoleskap = 'Innbo_OdelagteMatvarerIFryserEllerKjoleskap',
    InnboSkadePaAndreEiendeler = 'Innbo_SkadeEllerTapAvAndreEiendeler',
    InnboSkadedyrSkadeinsekter = 'InnboSkadedyrSkadeinsekter',
    SkadeEiendeler = 'Hjem_SkadeEiendeler',

    HusOgHytteGlasskadeVinduEllerDor = 'Glass i vindu eller dør',
    HusOgHytteGlasskadeSanitarporselenEllerDusjvegg = 'Sanitærporselen eller dusjvegg',
    HusOgHytteGlasskadePlatetoppEllerKomfyr = 'Glass i platetopp eller komfyr',
    HusOgHytteGlasskadeAnnen = 'Annen glasskade',

    AvbestillingEllerOmbooking = 'Reise_AvbestillingEllerOmbooking',
    ForsinketBagasje = 'Reise_ForsinketBagasje',
    ForsinketTransport = 'Reise_ForsinketTransport',
    TyveriInnbruddEllerRan = 'Reise_TyveriInnbruddEllerRan',
    AndreSkaderUnderReise = 'Reise_AndreSkaderUnderReise',
    ReiseSykdomUlykkeEllerDodsfallPaReisen = 'Reise_SykdomUlykkeEllerDodsfall_PaReisen',
    ReiseSykdomEllerUlykkePaReisen = 'Reise_SykdomEllerUlykke_PaReisen',
    ReiseAlvorligSykdomEllerDodsfallAvbrutt = 'Reise_AlvorligSykdomEllerDodsfall_Avbrutt',
    ReiseMistetReisegods = 'Reise_Mistet_Reisegods',
    ReiseSkadetReisegods = 'Reise_SkadetReisegods',
    ReiseGjenglemtReisegods = 'Reise_Gjenglemt_Reisegods',

    KollisjonskadePaKjoretoy = 'Kjoretoy_KollisjonskadePaKjoretoy',
    Feilfylling = 'Kjoretoy_Feilfylling',
    VarrelaterteSkader = 'Kjoretoy_VarrelaterteSkader',
    BrannskadeKjoretoy = 'Brannskade_Kjoretoy',
    MotorOgAndreMaskinskader = 'Kjoretoy_MotorOgAndreMaskinskader',
    KjoretoySkadePaParkertKjoretoy = 'Kjoretoy_SkadePaParkertKjoretoy',
    KollisjonBulkingHarvarkPaParkertKjoretoy = 'Kjoretoy_KollisjonBulkingHarvarkPaParkertKjoretoy',
    TakrasPaParkertKjoretoy = 'Kjoretoy_TakrasPaParkertKjoretoy',
    MistetEllerOdelagtBilnokkel = 'Kjoretoy_MistetEllerOdelagtBilnokkel',
    TyveriAvNokkel = 'Kjoretoy_TyveriAvBilnokkel',
    KjoretoyTyveri = 'Kjoretoy_KjoretoyTyveri',
    Glasskade = 'Kjoretoy_Glasskade',
    Veihjelp = 'Kjoretoy_Veihjelp',
    AndreSkader = 'Kjoretoy_AndreSkader',

    KollisjonMedAnnetKjoretoy = 'Kollisjon med et annet kjøretøy',
    KollisjonskadePaKjoretoyAutovernSkiltEl = 'Kollisjon med autovern eller skilt',
    KollisjonskadePaKjoretoyUtforkjoring = 'Utforkjøring',
    KollisjonskadePaKjoretoyHusMurkantEl = 'Kollisjon med hus/garasje/murkant e.l ',
    KollisjonskadePaKjoretoySteinIsEllerAnnetObjekt = 'Kjørte over en gjenstand som skadet kjøretøyet',
    KollijsonskadePaKjoretoyDyr = 'Påkjørsel av dyr',
    KollisjonskadePaKjoretoyMykTrafikant = 'Påkjørsel av syklist eller fotgjenger',

    KjoretoyTyveriInnbrudd = 'Innbrudd i kjøretøy',
    KjoretoyTyveriStjaletOgFunnet = 'Kjøretøyet var stjålet og er funnet',
    KjoretoyTyveriStjaletOgIkkeFunnet = 'Kjøretøyet er stjålet og er ikke funnet',

    BatKollisjonsskade = 'Bat_Kollisjonsskade',
    BatKollisjonskadeHolmeEllerSkjar = 'Bat_Kollisjon_Holme_Eller_Skjar',
    BatKollisjonskadeFlytendeGjenstand = 'Bat_Kollisjon_Flytende_Gjenstand',
    BatKollisjonskadeMedAnnenBat = 'Bat_Kollisjon_Med_Annen_Bat',
    BatKollisjonskadeMedBryggeEllerFastland = 'Bat_Kollisjon_Med_Brygge_Eller_Fastland',
    BatHarSunket = 'Baten_Har_Sunket',
    BatenHarSlittFortoyningOgBlittSkadet = 'Baten_Har_Slitt_Fortoyning_Og_Blitt_Skadet',
    BatTyveriEllerInnbrudd = 'Baten_Tyveri_Eller_Innbrudd',
    BatInnbrudd = 'Innbrudd i båten',
    BatStjaletOgFunnet = 'Båten var stjålet og er funnet',
    BatStjaletOgIkkeFunnet = 'Båten er stjålet og er ikke funnet',
    BatMaskinskader = 'Bat_Maskinskader',

    PersonskadeUlykke = 'Personskade_Ulykke',
    PersonskadeUforhet = 'Personskade_Uforhet',
    PersonskadeDodsfall = 'Personskade_Dodsfall',
    PersonskadeBarneOgUngdomsforsikring = 'Personskade_BarneOgUngdomsforsikring',
    PersonskadeKritiskSykdom = 'Personskade_KritiskSykdom',
    PersonskadeAnnet = 'Personskade_Annet',

    Rettshjelp = 'Rettshjelp',
    RettshjelpPrivat = 'Rettshjelp_Privat',
    RettshjelpLandbruk = 'Rettshjelp_Landbruk',
    RettshjelpNaring = 'Rettshjelp_Naring',
    RettshjelpTvistKjopSalgBolig = 'Rettshjelp_Tvist_Kjop_Salg_Bolig',
    RettshjelpTvistKjoretoy = 'Rettshjelp_Tvist_Kjoretoy',
    RettshjelpTvistEntreprenorEllerHandverker = 'Rettshjelp_Tvist_Entreprenor_Eller_Handverker',
    RettshjelpTvistNabo = 'Rettshjelp_Tvist_Nabo',
    RettshjelpTvistJordskifteEllerFesterett = 'Rettshjelp_Tvist_Jordskifte_Eller_Festerett',
    RettshjelpTvistOffentligForvaltningsvedtak = 'Rettshjelp_Tvist_Offentlig_Forvaltningsvedtak',
    RettshjelpTvistAnnet = 'Rettshjelp_Tvist_Annet',

    Naring = 'Naring',
    NaringNaringsbyggOgEiendeler = 'Naring_Naringsbygg_Og_Eiendeler',
    NaringLosoreEiendel = 'Naring_Losore_Eiendel',
    NaringTyveriUnderslag = 'Naring_Tyveri_Underslag',
    NaringBygningsglass = 'Naring_Bygningsglass',
    Landbruk = 'Landbruk',

    LandbrukLosore = 'Landbruk_Losore',
    LandbrukAvling = 'Landbruk_Avling',
    LandbrukDriftsbygninger = 'Landbruk_Driftsbygninger',
    LandbrukBrannvarslingsanlegg = 'Landbruk_Brannvarslingsanlegg',
    LandbrukMelkerobot = 'Landbruk_Melkerobot',

    LandbrukProduksjonsdyrStorfe = 'Landbruk_Produksjonsdyr_Storfe',
    LandbrukProduksjonsdyrSauGeit = 'Landbruk_Produksjonsdyr_SauGeit',
    LandbrukProduksjonsdyrGris = 'Landbruk_Produksjonsdyr_Gris',
    LandbrukProduksjonsdyrFjorfe = 'Landbruk_Produksjonsdyr_Fjorfe',
    LandbrukProduksjonsdyrHusdyrIndividuell = 'Landbruk_Produksjonsdyr_HusdyrIndividuell',

    Ansvar = 'Ansvar',
    AnsvarPrivat = 'Ansvar_Privat',
    AnsvarPrivatPersonskade = 'Ansvar_Privat_Personskade',
    AnsvarPrivatTingskade = 'Ansvar_Privat_Tingskade',
    AnsvarLandbruk = 'Ansvar_Landbruk',
    AnsvarNaring = 'Ansvar_Naring',
    AnsvarLandbrukNaringFormueskade = 'Ansvar_Landbruk_Naring_Formueskade',
    AnsvarLandbrukNaringTingskade = 'Ansvar_Landbruk_Naring_Tingskade',

    BygningLekkasjeOgVannskaderLekkasjeFraRorIBoligen = 'Bygning_LekkasjeOgVannskader_LekkasjeFraRorIBoligen',
    BygningLekkasjeOgVannskaderLekkasjeFraRorPaTomten = 'Bygning_LekkasjeOgVannskaderLekkasjeFraRorPaTomten',
    BygningLekkasjeOgVannskaderTilbakeslag = 'Bygning_LekkasjeOgVannskaderTilbakeslag',
    BygningLekkasjeOgVannskaderVannskadeFraHustakEllerYttervegg = 'Bygning_LekkasjeOgVannskaderVannskadeFraHustakEllerYttervegg',
    BygningLekkasjeOgVannskaderVvannskadeIKjeller = 'Bygning_LekkasjeOgVannskaderVvannskadeIKjeller',
    BygningLekkasjeOgVannskaderAnnenVannskade = 'Bygning_LekkasjeOgVannskaderAnnenVannskade',

    DyrHund = 'DyrHund',
    DyrKatt = 'DyrKatt',
    DyrHest = 'DyrHest',
    DyrAnnet = 'DyrAnnet',
}
